// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {noop} from 'lodash';

// Components
import Button from './button';

// Styles
import './drawer.scss';

export default class Drawer extends Component {
    state = {open: true};

    componentDidMount() {
        const {animationDelay = 1500, autoClose} = this.props;

        if (autoClose) {
            setTimeout(this.closeDrawer, animationDelay);
        }
    }

    getClass() {
        const {open} = this.state;
        const {className} = this.props;

        return classnames(
            {
                drawer: true,
                drawer_close: !open,
            },
            className
        );
    }

    closeDrawer = () => {
        const {animationDelay = 1500, onClose = noop} = this.props;

        this.setState({open: false}, () => {
            setTimeout(onClose, animationDelay); // Be sure this is longer than the CSS animation
        });
    };

    handleCloseClick = (event) => {
        event && event.preventDefault && event.preventDefault();

        this.closeDrawer();
    };

    render() {
        const {children} = this.props;

        return children ? (
            <div className={this.getClass()}>
                <Button className="drawer--button" icon="window-close" onClick={this.handleCloseClick} />
                {children}
            </div>
        ) : null;
    }
}

Drawer.propTypes = {
    animationDelay: PropTypes.number,
    autoClose: PropTypes.bool,
    children: PropTypes.node,
    className: PropTypes.string,
    onClose: PropTypes.func,
};
